import React from "react";
import "../../assets/scss/mygrid.scss";
import { useState, useEffect } from "react";
import { getAllStrategiesSheet } from "../../services/StrategySheetService";
import { isLargeScreen } from "../../utilities/ScreenView";

const StrategiesSheet = () => {

    const [strategiessheet, setStrategiessheet] = useState([]);
    var countGridRows = 0;

    useEffect(() => {
        const interval = setInterval(() => { listStrategiesSheet(); }, 10000);
        return () => { clearInterval(interval); }
    }, []);

    function listStrategiesSheet() {
        getAllStrategiesSheet()
            .then((response) => {
                setStrategiessheet(response.data);
            })
            .catch((error) => {
                console.error(error);
            });
    }

    function isOdden() {
        ++countGridRows;
        if (countGridRows % 2 === 0) return false;
        return true;
    }

    function showInLargeScreen() {
        return (
            <div className="container">
                <table className="table">
                    {strategiessheet.length > 0 ?
                        <thead style={{ fontSize: '12px' }} className="fw-lighter bg-primary bg-gradient text-white">
                            <tr>
                                <th>Date</th>
                                <th>Strategy</th>
                                <th>Time</th>
                                <th>Ticker</th>
                                <th>Bid</th>
                                <th>Pips</th>
                                <th>Spread</th>
                                <th>Range</th>
                                <th>SMA20 High</th>
                                <th>SMA20 Low</th>
                                <th>TDI</th>
                                <th>RSI14</th>
                                <th>Trange</th>
                            </tr>
                        </thead>
                        : ""
                    }
                    <tbody>
                        {strategiessheet.length > 0 ?
                            strategiessheet.map((strategysheet) => (
                                <tr style={{ fontSize: 'small' }}
                                    className={isOdden() ? "small table-active" : "small table-light"}
                                    key={strategysheet.id}>

                                    <td data-label="Date">
                                        {new Date(strategysheet.timestamp).toLocaleString("en-GB", {
                                            month: "short",
                                            weekday: "short",
                                            day: "2-digit",
                                            year: "2-digit",
                                            hour: "2-digit",
                                            minute: "2-digit",
                                        })}
                                    </td>

                                    <td className="text-secondary" data-label="Strategy">
                                        {strategysheet.strategy}
                                    </td>

                                    <td data-label="Time">
                                        {strategysheet.period}
                                    </td>

                                    <td className="text-secondary" data-label="Ticker">
                                        {strategysheet.ticker}
                                    </td>

                                    <td data-label="Ask">
                                        {strategysheet.ask.toFixed(5)}
                                    </td>

                                    {strategysheet.pips < 0 ?
                                        <td className="bg-danger text-center" data-label="Pips">{strategysheet.pips.toFixed(1)}</td>
                                        : strategysheet.pips === 0 ?
                                            <td className="bg-warning text-center" data-label="Pips">{strategysheet.pips.toFixed(1)}</td>
                                            : <td className="bg-success text-center" data-label="Pips">{strategysheet.pips.toFixed(1)}</td>
                                    }

                                    <td className="text-center" data-label="Spread">
                                        {strategysheet.spread.toFixed(1)}
                                    </td>

                                    {strategysheet.sumpips < 0 ?
                                        <td className="text-danger text-center" data-label="Pips">{strategysheet.sumpips.toFixed(1)}</td>
                                        : strategysheet.sumpips === 0 ?
                                            <td className="text-warning text-center" data-label="Pips">{strategysheet.sumpips.toFixed(1)}</td>
                                            : <td className="text-success text-center" data-label="Pips">{strategysheet.sumpips.toFixed(1)}</td>
                                    }

                                    <td data-label="SMA20 High">
                                        {strategysheet.sma20h >= 0 ? strategysheet.sma20h.toFixed(5) : "" }
                                    </td>
                                    <td data-label="SMA20 Low">
                                        {strategysheet.sma20l >= 0 ? strategysheet.sma20l.toFixed(5) : "" }
                                    </td>
                                    <td data-label="TDI">
                                        {strategysheet.tdi >= 0 ? strategysheet.tdi.toFixed(2) : "" }
                                    </td>
                                    <td data-label="RSI14">
                                        {strategysheet.rsi14 >= 0 ? strategysheet.rsi14.toFixed(2) : "" }
                                    </td>
                                    <td data-label="Trange">
                                        {strategysheet.trange >= 0 ? strategysheet.trange.toFixed(4) : ""}
                                    </td>
                                </tr>))
                            : ""}
                    </tbody>
                </table>
            </div>
        )
    }

    function showInMobileScreen() {
        return (
            <div className="container">
                <table className="table">
                    {strategiessheet.length > 0 ?
                        <thead style={{ fontSize: '11px' }} className="fw-lighter bg-primary bg-gradient text-white">
                            <tr>
                                <th>Strategy</th>
                                <th>Ticker</th>
                                <th>Pips</th>
                                <th>Range</th>
                                <th>TDI</th>
                                <th>RSI14</th>
                            </tr>
                        </thead>
                        : ""
                    }
                    <tbody>
                        {strategiessheet.length > 0 ?
                            strategiessheet.map((strategysheet) => (
                                <tr style={{ fontSize: '12px' }}
                                    className={isOdden() ? "small table-active" : "small table-light"}
                                    key={strategysheet.id}>

                                    <td className="text-secondary" data-label="Strategy">
                                        {strategysheet.strategy}
                                    </td>

                                    <td className="text-secondary" data-label="Ticker">
                                        {strategysheet.ticker}
                                    </td>

                                    {strategysheet.pips < 0 ?
                                        <td className="bg-danger text-center" data-label="Pips">{strategysheet.pips.toFixed(1)}</td>
                                        : strategysheet.pips === 0 ?
                                            <td className="bg-warning text-center" data-label="Pips">{strategysheet.pips.toFixed(1)}</td>
                                            : <td className="bg-success text-center" data-label="Pips">{strategysheet.pips.toFixed(1)}</td>
                                    }

                                    {strategysheet.sumpips < 0 ?
                                        <td className="text-danger text-center" data-label="Pips">{strategysheet.sumpips.toFixed(1)}</td>
                                        : strategysheet.sumpips === 0 ?
                                            <td className="text-warning text-center" data-label="Pips">{strategysheet.sumpips.toFixed(1)}</td>
                                            : <td className="text-success text-center" data-label="Pips">{strategysheet.sumpips.toFixed(1)}</td>
                                    }

                                    <td data-label="TDI">
                                        {strategysheet.tdi >= 0 ? strategysheet.tdi.toFixed(2) : "" }
                                    </td>
                                    <td data-label="RSI14">
                                        {strategysheet.rsi14 >= 0 ? strategysheet.rsi14.toFixed(2) : "" }
                                    </td>
                                </tr>))
                            : ""}
                    </tbody>
                </table>
            </div>
        )
    }    

    return (
        <>
            { isLargeScreen() ? showInLargeScreen() : showInMobileScreen() }
        </>
    );
};

export default StrategiesSheet;
